<div class="artifact-type-container">
  <select class="artifact-type-select" [(ngModel)]="selectedArtifactType" (change)="onArtifactTypeChange()">
    <option value="" disabled selected hidden>Artifact type</option>
    <option *ngFor="let type of artifactTypes" [value]="type.value">
      {{ type.label }}
    </option>
  </select>
</div>

<div class="busniess-review-content">
  <div class="header-content" *ngFor="let name of artifactNames">
    <div class="artifact-container-header">
      <mat-icon class="chevron-icon" (click)="onArtifactClick(name.artifact_id)">
        {{ expandedArtifactId === name.artifact_id ? 'expand_more' : 'chevron_right' }}
      </mat-icon>
      <strong>
        <span class="title">{{ name.artifact_name }}</span>
      </strong>
    </div>

    <!-- Review comments container -->
    <div class="details-container" *ngIf="expandedArtifactId === name.artifact_id" [@slideInOut]="'open'">
      <div class="details-content">
        <div class="review-section" *ngFor="let review of artifactReviews[name.artifact_id]">
          <div class="review-container" [class.resolved]="review.resolved">
            <!-- Review -->
            <div>
              <div class="created-by">
                <p class="reviewer-name">{{ review.created_by }}</p>
                <div class="time-more-container">
                  <div class="review-time">({{ review.created_time | date:'short' }})</div>
                  <mat-icon [matMenuTriggerFor]="reviewCommentMenu" class="btn-icon" [featureActionState]="'BUSINESS_REVIEW'">more_verti</mat-icon>
                </div>
              </div>

              <mat-menu #reviewCommentMenu="matMenu" [disabled]="review.resolved">
                <button mat-menu-item (click)="editReview(review._id)" [disabled]="review.resolved" [featureActionState]="'BUSINESS_REVIEW'">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
                <button mat-menu-item (click)="deleteReview(name.artifact_id , review._id)" [disabled]="review.resolved" [featureActionState]="'BUSINESS_REVIEW'">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>

              <div class="review-details">
                <div class="review-body" *ngIf="editableReviewId !== review._id">
                  <a [href]="review.report_link" target="_blank" rel="noopener noreferrer" class="review-link">
                    {{ review.review_comment }}
                  </a>
                </div>
                <div class="edit-review-container" *ngIf="editableReviewId == review._id">
                  <textarea [(ngModel)]="review.review_comment"
                    placeholder="Type your review here..."></textarea>
          
                  <div class="review_btn">
                    <button class="cancel-update-btn" (click)="saveReview(review._id, review.review_comment)" [featureActionState]="'BUSINESS_REVIEW'">Update Review</button>
                    <button class="cancel-update-btn" (click)="cancelReviewEdit()">Cancel</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Replies -->
            <div class="reply" *ngIf="review.replies && review.replies.length">
              <div class="reply-block" *ngFor="let reply of review.replies">

                <div class="created-by">
                  <p class="reviewer-name">{{ reply.created_by }}</p>
                  <div class="time-more-container">
                    <div class="review-time">({{ reply.created_time | date:'short' }})</div>
                    <mat-icon [matMenuTriggerFor]="reviewCommentMenu" class="btn-icon" [featureActionState]="'BUSINESS_REVIEW'">more_verti</mat-icon>
                  </div>
                </div>
  
                <mat-menu #reviewCommentMenu="matMenu" [disabled]="review.resolved">
                  <button mat-menu-item (click)="editReply(reply._id)" [disabled]="review.resolved" [featureActionState]="'BUSINESS_REVIEW'">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="deleteReply( name.artifact_id , review._id ,reply._id)" [disabled]="review.resolved" [featureActionState]="'BUSINESS_REVIEW'">
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
  
                <!-- edit reply -->
                <div class="review-details">
                  <div class="review-body" *ngIf="editableReplyId !== reply._id">
                    <p>{{ reply.reply_comment }}</p>
                  </div>
                  <div class="edit-review-container" *ngIf="editableReplyId === reply._id">
                    <textarea [(ngModel)]="reply.reply_comment"
                      placeholder="Type your reply here..."></textarea>
            
                    <div class="review_btn">
                      <button class="cancel-update-btn" (click)="saveReply(review._id, reply._id, reply.reply_comment)" [featureActionState]="'BUSINESS_REVIEW'">Update Reply</button>
                      <button class="cancel-update-btn" (click)="cancelReplyEdit()">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>              
            </div>       
            
            <div class="review-actions">
              <div *ngIf="replyingToReviewId !== review._id" class="reply-btn-block">
                <button class="cancel-update-btn" (click)="enableReplyInput(review._id)" [disabled]="review.resolved" [featureActionState]="'BUSINESS_REVIEW'">💬 Reply</button>
              </div>
              <!-- New reply input box -->
  
              <div class="edit-review-container" *ngIf="replyingToReviewId === review._id">
                <textarea [(ngModel)]="newReplyComment"
                  placeholder="Type your reply here..."></textarea>
        
                <div class="review_btn">
                  <button class="cancel-update-btn" (click)="submitReply(name.artifact_id ,review._id)" [featureActionState]="'BUSINESS_REVIEW'">Submit Reply</button>
                  <button class="cancel-update-btn" (click)="cancelReply()">Cancel</button>
                </div>
              </div>
              <div>              
                <button class="cancel-update-btn" (click)="toggleReviewResolved(review._id)" [featureActionState]="'BUSINESS_REVIEW'">
                  {{ review.resolved ? 'Unresolve' : 'Resolve' }}
                </button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
   <!-- ✅ Pagination goes here, after the list of artifacts -->
   <div class="pagination-controls">
    <button (click)="prevPage()" [disabled]="currentPage === 0" mat-icon-button> <mat-icon>chevron_left</mat-icon></button>
    <span>Page {{ currentPage + 1 }}</span>
    <button (click)="nextPage()" [disabled]="!hasNextPage" mat-icon-button><mat-icon>chevron_right</mat-icon></button>
  </div>
</div>
  